// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import Dialog from 'presentations/views/components/atoms/Dialog';
import CalendarList from './components/CalendarList';
import EmptyContent from 'presentations/views/components/organisms/EmptyContent';
import { ErrorList } from 'domains/models';
import {
  AccountCalendarListItem,
  AccountListItem,
} from 'presentations/api/schema/account';
import { UserCalendarCreate } from 'presentations/api/schema/user_calendar';

interface Props {
  onClose?: any;
  googleAuthUrl: string;
  microsoftAuthUrl: string;
  // hooks state
  isLoading?: boolean;
  accounts: AccountListItem[];
  accountCalendars: AccountCalendarListItem[];
  selectedCalendars: UserCalendarCreate[];
  calendarErrors: ErrorList;
  // hooks actions
  onCalendarSelect?: any;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <Dialog
      isOpen
      title={t('title')}
      onClose={props.onClose}
      scroll
      maxHeight="50vh"
    >
      <CalendarList
        isAccountDeletable={false}
        isLoading={props.isLoading}
        accounts={props.accounts}
        accountCalendars={props.accountCalendars}
        selectedCalendars={props.selectedCalendars}
        googleAuthUrl={props.googleAuthUrl}
        microsoftAuthUrl={props.microsoftAuthUrl}
        calendarErrors={props.calendarErrors}
        onCalendarSelect={props.onCalendarSelect}
        hideCalendarSetting
      />
      {!props.isLoading && props.accounts.length === 0 && (
        <EmptyContent content={t('no content')} />
      )}
    </Dialog>
  );
}
